export default "__VITE_ASSET__qQ7xm$WX__"